import { useAuth0 } from "@auth0/auth0-react";
import PropTypes from "prop-types";
import { useState } from "react";
import { useIdleTimer } from "react-idle-timer";

const IdleTimer = ({ onIdle, idleTimeout, promptBeforeIdle }) => {
  const [isIdle, setIdle] = useState(false);
  const { logout } = useAuth0();
  const returnTo = window.location.origin;
  const handleIdle = () => {
    setIdle(true);
    idleTimer.disabled = true;
    logout({ returnTo });
  };

  const idleTimer = useIdleTimer({
    timeout: idleTimeout,
    promptBeforeIdle,
    onPrompt: onIdle,
    onIdle: handleIdle,
    debounce: 500,
  });
  return {
    isIdle,
    setIdle,
    idleTimer,
    getRemainingTime: idleTimer.getRemainingTime,
    getLastActiveTime: idleTimer.getLastActiveTime,
  };
};

IdleTimer.propTypes = {
  onIdle: PropTypes.func,
  idleTimeout: PropTypes.number,
  promptBeforeIdle: PropTypes.number,
};

export default IdleTimer;
